import './popularMovies';
import './js/body-logic/modal-win/modal';
import "./js/body-logic/modal-win/modal-btn"
import './js/body-logic/colorTheme';
import './js/body-logic/sortByTags';
import './js/body-logic/scrollToTop';
import './js/header-logic/input';
import './js/body-logic/auth-site-change';
import './js/body-logic/authentification'
